/**
 * isEmpty
 * checks value for being empty.
 * returns false for any numeric value
 * @param val mixed
 * @returns {boolean} is value empty
 */
const isEmpty = (val) => {
    if (typeof val === 'number') {
        return false;
    }
    const trimmedVal = (typeof val === 'string') ? val.trim() : val;
    return !trimmedVal;
};

/**
 * getWins
 * extracts wins amount from winsTips api fields
 * @param winsTips
 * @return Number wins
 */
const getWins = winsTips =>
    (isEmpty(winsTips) ? null : +winsTips.split('-')[0]);
/**
 * getBet
 * extracts bet value from napsBet api field
 * @param napsBet
 * @return Number bet
 */
const getBet = napsBet =>
    (isEmpty(napsBet) ? null : +(napsBet.slice(0, 1) + napsBet.slice(2)));
/**
 * getPercents
 * extracts Percents value from favsTipped api field
 * @param favsTipped
 * @return Number Percents
 */
const getPercents = (favsTipped) => {
    if (isEmpty(favsTipped)) {
        return null;
    }

    return +favsTipped.split('%')[0];
};

const getCurSeq = (curSeq) => {
    if (isEmpty(curSeq)) {
        return null;
    }

    const match = curSeq.match(/[a-zA-Z]/);
    if (!match) {
        return null;
    }

    const num = curSeq.slice(0, match.index);
    const signCode = curSeq.slice(match.index, curSeq.length);

    return signCode === 'L' ? -num : +num;
};

const getBetWithCur = (napsBet, curSeq) =>
    (isEmpty(napsBet) ? '—' : `${napsBet} ${curSeq}`);

const sortAlphabetical = (a, b) => {
    if (a === b) {
        return 0;
    }

    return a < b ? -1 : 1;
};

const sortNumerical = (a, b) => b - a;

const createSortFn = getValue => key => (itemA, itemB) => {
    const a = getValue(itemA[key]);
    const b = getValue(itemB[key]);

    if (!a) {
        return 1;
    }

    if (!b) {
        return -1;
    }

    if (isNaN(a - b)) {
        return sortAlphabetical(a, b);
    }

    return sortNumerical(a, b);
};

export const sortPercents = createSortFn(getPercents);
export const sortBets = createSortFn(getBet);
export const sortWins = createSortFn(getWins);
export const sortCurSeq = createSortFn(getCurSeq);

const trimEmptyValues = item => Object.keys(item).reduce((acc, key) =>
    ({ ...acc, [key]: isEmpty(item[key]) ? null : item[key], }), {});

export const addBetWithCur = data =>
    data.map(item => ({
        ...trimEmptyValues(item),
        betWithCur: getBetWithCur(item.napsBet, item.curSeq),
    }));




// WEBPACK FOOTER //
// ./src/js/pressChallenge/utils.js